import useFilters, { type FiltersProps, type FiltersType } from './useFilters';
/* eslint-disable-next-line import/no-cycle */
import useQuery, { type QueryProps, type QueryType } from './useQuery';
import useOrder, { type OrderProps, type OrderType } from './useOrder';
import usePaginator, { type PaginatorProps, type PaginatorType } from './usePaginator';

export type PaginationProps = {
	id?: string;
	module: string;
	filter?: Omit<FiltersProps, 'id' | 'module'> & Omit<QueryProps, 'module'>;
	order?: OrderProps;
	paginator?: PaginatorProps;
};

export interface PaginationType {
	filterProps: FiltersType & QueryType;
	orderProps: OrderType;
	paginatorProps: PaginatorType;
}

export default function usePagination(props: PaginationProps) {
	const filterProps = useFilters({ id: props.id, module: props.module, ...props.filter });
	const queryProps = useQuery({ module: props.module, defaultQuery: props.filter?.defaultQuery });
	const orderProps = useOrder(props.order || {});
	const paginatorProps = usePaginator(props.paginator);

	return {
		filterProps: {
			...filterProps,
			...queryProps,
			handleFiltersApply: () => {
				paginatorProps.setNPage(1);
				return filterProps.handleFiltersApply();
			},
			handleFiltersClear: () => {
				paginatorProps.setNPage(1);
				filterProps.handleFiltersClear();
			},
			handleQueryApply: () => {
				paginatorProps.setNPage(1);
				queryProps.handleQueryApply();
			},
			handleQueryClear: () => {
				paginatorProps.setNPage(1);
				queryProps.handleQueryClear();
			}
		},
		orderProps: orderProps,
		paginatorProps: paginatorProps
	} as PaginationType;
}
